import request from '@/utils/request'

// 企微群组更新
export function wechatcomupwechatgroup(id, account_id, company_id, group_name, message, timeHi, include_status) {
  return request({
    url: `/wechat/wechat_group/${id}`,
    method: 'PUT',
    data: {
      account_id,
      company_id,
      group_name,
      message,
      timeHi,
      include_status
    }
  })
}

// 企业筛选列表
export function enterpriseMicro() {
  return request({
    url: `/workWechat/corpV3/list`,
    method: 'get'
  })
}

// 获取预定头像
export function getavatarList() {
  return request({
    url: `/workWechat/kfV3/avatarList`,
    method: 'get'
  })
}

// 企业员工列表
export function getstaffList(params) {
  return request({
    url: `/workWechat/userV3/list`,
    method: 'get',
    params
  })
}

// 客服列表
export function customerservicelist(params) {
  return request({
    url: `/workWechat/kfV3/index`,
    method: 'get',
    params
  })
}

// 客服删除
export function customerservicedelte(data) {
  return request({
    url: `/workWechat/kfV3/destroy`,
    method: 'post',
    data
  })
}

// 客服更新
export function updayaservicedelte(data) {
  return request({
    url: `/workWechat/kfV3/update`,
    method: 'post',
    data
  })
}

// 更新部门成员
export function updateDepartment(data = {}) {
  return request({
    url: `/workWechat/corpV3/updateDepartment`,
    method: 'post',
    data
  })
}

// 新增条数
export function updayaservicedelter(data) {
  return request({
    url: `/workWechat/kfV3/addLink`,
    method: 'post',
    data
  })
}

// 预添加微信客服
export function beforehandstore(data) {
  return request({
    url: `/workWechat/kfV3/beforehandStore`,
    method: 'post',
    data
  })
}

// 换一批客服人员
export function changebatch(params) {
  return request({
    url: `/workWechat/kfV3/changeBatch`,
    method: 'get',
    params
  })
}

// 企微公司列表
export function wechatcompanying(params) {
  return request({
    url: `/wechat/wechat_company`,
    method: 'get',
    params
  })
}

// 企微账户列表
export function wechatcompanyingaccount(params) {
  return request({
    url: `/wechat/wechat_company_account`,
    method: 'get',
    params
  })
}

// 数据
export function alldatalist(params) {
  return request({
    url: `/workWechat/kfV3/countData`,
    method: 'get',
    params
  })
}

export function payrecordr(id, params) {
  return request({
    url: `/wechat/wechat_group/record/${id}`,
    method: 'get',
    params
  })
}

// 获取企微公司列表
export function getMicroEnterprise(params = {}) {
  return request({
    url: `/workWechat/corpV3/index`,
    method: 'get',
    params
  })
}

// 新建企微公司
export function newEnterpriseAndMicro(data = {}) {
  return request({
    url: `/workWechat/corpV3/store`,
    method: 'post',
    data
  })
}

// 删除企微公司
export function delteMicro(id) {
  return request({
    url: `/workWechat/corpV3/destroy`,
    method: 'post',
    data: {
      corp_id: id
    }
  })
}

export function wechatcomupdataaccountr(data) {
  return request({
    url: `/workWechat/corpV3/update`,
    method: 'post',
    data
  })
}

// 企微公司更新
export function wechatcomupdata(id, company_name, clock_in) {
  return request({
    url: `/wechat/wechat_company/${id}`,
    method: 'PUT',
    data: {
      company_name,
      clock_in
    }
  })
}

// 企微账户添加
export function wechatcompanyaccount(data) {
  return request({
    url: `/wechat/wechat_company_account`,
    method: 'post',
    data
  })
}

// 企微账户更新
export function wechatcomupdataaccount(id, account, phone) {
  return request({
    url: `/wechat/wechat_company_account/${id}`,
    method: 'PUT',
    data: {
      account,
      phone
    }
  })
}

// 企微账户删除
export function deletetestwechatraccount(id) {
  return request({
    url: `/wechat/wechat_company_account/${id}`,
    method: 'DELETE'
  })
}

// 客服消息创建2
export function customerservicecreatv2(data) {
  return request({
    url: '/workWechat/kfV3/storeV3',
    method: 'post',
    data
  })
}
// 企业对外员工
export function getFollowUserList(params) {
  return request({
    url: `/workWechat/corpV3/getFollowUserList`,
    method: 'get',
    params
  })
}
// 复制授权链接
export function copyAuthlink(params) {
  return request({
    url: `/workWechat/corpV3/getFollowUserList`,
    method: 'get',
    params
  })
}
// 微信客服服务商
export function getSuiteList(params) {
  return request({
    url: `/workWechat/kfV3/getSuiteList`,
    method: 'get',
    params
  })
}
// 微信客服服务商创建
export function getSuiteListcreate(data) {
  return request({
    url: '/workWechat/kfV3/suiteStore',
    method: 'post',
    data
  })
}
// 微信客服服务商获取授权链接
export function builderAuthUrl(params) {
  return request({
    url: `/workWechat/kfV3/builderAuthUrl`,
    method: 'get',
    params
  })
}
// 飞书人员列表
export function workWechatKfV3FsLists(params) {
  return request({
    url: `/workWechat/kfV3/fsLists`,
    method: 'get',
    params
  })
}
// 客服链接设置飞书人员

export function workWechatKfV3SetFsOpenId(data) {
  return request({
    url: `/workWechat/kfV3/setFsOpenId`,
    method: 'post',
    data
  })
}

// 复制客服创建V3
export function copyStoreV3(data) {
  return request({
    url: `/workWechat/kfV3/copyStoreV3`,
    method: 'post',
    data
  })
}
